import { categoryGQLSchema } from "./Category";
import { userGQLSchema } from "./User";

export const articleGQLSchema = `
id
MainInfo{
    Title
    Slug
    Author
    Category{
        ${categoryGQLSchema}
    }
    Source{
        Name
        Link
    }
}
MainImage{
    FilePath
    Alt
}
Content
Seo{
    Keywords
    Description
}
Attachments{
    id
    FilePath
    Alt
}
Infos{
    Views
    Shortcut
    CreatedAt
    UpdatedAt
    CreatedBy{
        ${userGQLSchema}
    }
    UpdatedBy{
        ${userGQLSchema}
    }
    Reedited
    OnMainNews
    Published
}
`;
